import { ButtonLink } from '@/components/ButtonLink';
import { MarkdownToJSX } from '@/components/MarkdownToJSX';
import type { NavigationCardFragment } from '@/utils/dato/generated';

export const NavigationCard = ({
  navigationCardDescription,
  buttonLabel,
  buttonLink,
  title,
}: NavigationCardFragment) => (
  <div className="bg-background shadow-[0px_1px_#D4D7D9] flex flex-col text-center rounded-xl p-6">
    <h2 className="text-2xl mb-3">{title}</h2>
    {navigationCardDescription ? <MarkdownToJSX md={navigationCardDescription} /> : null}
    <ButtonLink className="w-full mt-auto" href={buttonLink}>
      {buttonLabel}
    </ButtonLink>
  </div>
);
